export const PAGE_ERROR = 'PAGE'; // eslint-disable-line import/prefer-default-export
